import React, { useEffect, useRef, useState } from "react";
import "../../../assets/css/new-website.css";

export default function HealthCareTemplate() {
  const sectionsRef = useRef([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && window.innerWidth <= 768) {
            // Get the index of the current section that is in view
            const index = sectionsRef.current.indexOf(entry.target);
            setActiveIndex(index); // Set the active index to trigger the hover effect
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is in view
    );

    // Observe each health-checkup section
    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect(); // Cleanup observer
  }, []);

  const sections = [
    {
      title: "Routine Tests",
      imgSrc: "/images/new-website/home-new/Lab-test.webp",
      imgLink: "/lab-tests",
      left: "Routine Test",
      leftBottom: "Heart Health",
      right: "Advanced Biomarkers",
    },
    {
      title: "Radiology Services",
      imgSrc: "/images/new-website/home-new/radiology-services.webp",
      imgLink: "/radiology",
      left: "Ultrasound",
      leftBottom: "X-ray",
      right: "Echo/TMT",
    },
    {
      title: "Physiotherapy",
      imgSrc: "/images/new-website/home-new/BH-Physiotherapy-home.webp",
      imgLink: "/physiotherapy",
      left: "Pain Management",
      leftBottom: "Sports Rehab",
      right: "Geriatric Care",
    },
    {
      title: "Dental Care",
      imgSrc: "/images/new-website/home-new/BH-Dental-home.webp",
      imgLink: "/dental-checkup",
      left: "Invisalign Aligners",
      leftBottom: "Dental Implants",
      right: "Crowns & Bridges",
    },
    {
      title: "Hearing Care",
      imgSrc: "/images/new-website/home-new/BH-Hearing-home.webp",
      imgLink: "/audio-care",
      left: "Screenings",
      leftBottom: "Audiometry",
      right: "Hearing Aids",
    },
    
  ];

  const newSections = [
    
    {
      title: "Metabolic Health",
      imgSrc: "/images/new-website/home-new/metabolic-health.webp",
      imgLink: "/metabolic",
      left: "Diabetes Care",
      leftBottom: "PCOS/PCOD",
      right: "Gut Health",
    },

    {
      title: "Adult Vaccines",
      imgSrc: "/images/new-website/home-new/adult-vaccine.webp",
      imgLink: "/adult-vaccination-program",
      left: "Flu Shots",
      leftBottom: "Shingles",
      right: "HPV Vaccine",
    },

    {
      title: "Smart Screenings",
      imgSrc: "/images/new-website/home-new/smart-screening.webp",
      imgLink: "/ai-health-screening",
      left: "Face Scan",
      leftBottom: "Breast Screening",
      right: "Body Composition Analysis (BCA)",
    },
    
    {
      title: "Women's Health",
      imgSrc: "/images/new-website/home-new/women-care-services.webp",
      imgLink: "/women-health",
      left: "Period & PCOS Care",
      leftBottom: "Fertility Wellness",
      right: "Menopause",
    },
    {
      title: "Elder Care",
      imgSrc: "/images/new-website/home-new/elder-care-services.webp",
      imgLink: "/elder-care",
      left: "Health Checks",
      leftBottom: "Hearing Care",
      right: "Fall Prevention",
    },
  ];

  const Card = ({ section, isActive, refHandler }) => (
    <div
      className={`health-checkup ${isActive ? "hovered" : ""}`}
      ref={refHandler}
    >
      <div className="hover-content">
        <div className="hover-text">
          <div className="left-desc top-disc">{section.left}</div>
          <div className="left-desc bottom-disc">{section.leftBottom}</div>
        </div>
        <div className="center-image">
          <a href={section.imgLink || "#"}>
            <img src={section.imgSrc} alt={section.title} />
          </a>
          <h3>{section.title}</h3>
        </div>
        <div className="right-desc">{section.right}</div>
      </div>
    </div>
  );

  return (
    <section>
      {/* Intro Section */}
      <div className="servive">
        <h2 className="heading1">
          Everything You
          <span className="highlight1"> Need for the Whole You</span>
          <br />
          In One Place
        </h2>
        <p className="text-[#0D0D0D] text-center mt-3">
          With our comprehensive health checkups & expert sessions, your
          healthcare needs are in good hands.
        </p>
      </div>

      {/* First Section */}
      <div className="healthcare-container-home">
        <div className="healthcare-grid">
          {sections.map((section, index) => (
            <Card
              key={`new-${index}`}
              section={section}
              index={index}
              isActive={activeIndex === index}
              refHandler={(el) => (sectionsRef.current[index] = el)}
            />
          ))}
        </div>

        <div className="healthcare-grid">
          {newSections.map((section, index) => (
            <Card
              key={`new-${index}`}
              section={section}
              index={index + sections.length} // Adjust index for the second group of sections
              isActive={activeIndex === index + sections.length}
              refHandler={(el) => (sectionsRef.current[index + sections.length] = el)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
